import { render, staticRenderFns } from "./RirekishoAiReasonCard.vue?vue&type=template&id=7b567552&scoped=true"
import script from "./RirekishoAiReasonCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoAiReasonCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RirekishoAiReasonCard.vue?vue&type=style&index=0&id=7b567552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b567552",
  null
  
)

export default component.exports